import * as React from 'react'
import { cn } from '@/lib/utils'

export interface FabProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Đẩy FAB lên trên bottom-nav (h-16) của DashboardLayout, cộng safe-area. */
  aboveBottomNav?: boolean
}

/**
 * Nút hành động chính nổi góc dưới phải — chỗ ngón cái với tới dễ nhất trên mobile.
 * Mặc định `fixed`, tự né bottom-nav (`desktop:hidden` trong DashboardLayout, cao 64px)
 * khi `aboveBottomNav`.
 *
 * Ẩn ở chế độ desktop — CÙNG NGƯỠNG với bottom-nav của DashboardLayout. Đây là
 * một giao kèo, không phải trùng hợp: FAB là hành động chính của giao diện
 * mobile, có thanh tab đáy thì phải có FAB.
 *
 * Hai lần ngưỡng này bị lệch đều sinh ra lỗi:
 *   - Lần 1: Fab ẩn ở `md` còn bottom-nav ẩn ở `lg` → khoảng 768–1024px có
 *     thanh tab nhưng mất hẳn hành động chính.
 *   - Lần 2: khung chuyển sang `desktop:` (nhận diện theo cảm ứng) còn Fab vẫn
 *     ở `lg:` → iPad Pro ngang 1366px có thanh tab nhưng lại mất FAB.
 *
 * Nên dùng `desktop:hidden` chứ đừng quay lại breakpoint bề rộng. Trang nào có
 * nút tương ứng ở header thì để nút đó `hidden desktop:inline-flex`.
 */
const Fab = React.forwardRef<HTMLButtonElement, FabProps>(
  ({ className, aboveBottomNav = true, style, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      data-slot="fab"
      className={cn(
        'fixed right-4 z-30 size-14 rounded-full bg-accent text-onAccent shadow-pop',
        'flex items-center justify-center active:scale-95 motion-layer',
        'desktop:hidden',
        className,
      )}
      style={{
        bottom: aboveBottomNav
          ? 'calc(4rem + env(safe-area-inset-bottom) + 0.75rem)'
          : 'calc(env(safe-area-inset-bottom) + 1rem)',
        ...style,
      }}
      {...props}
    />
  ),
)
Fab.displayName = 'Fab'

export { Fab }
